import React from 'react';
import {IGamesFilterStrategy} from "../games-filter-strategy.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {GamesMap} from "../../../games/games.service.interface";
import {Nullable} from "../../../../../common/types/nullable-types";
import {IFilterIndicatorRenderingOptions} from "../../games-filter.service.interface";

export class NoGamesFilterStrategy implements IGamesFilterStrategy {
    constructor(private readonly services: IServiceFactoryExtended) {
    }
    get filteredGamesMap(): GamesMap {
        return this.services.games.gamesMap;
    }
    readonly isFilteringAvailable: boolean = false;

    renderMobileFiltersIndicator(): React.ReactElement {
        return null;
    }

    renderFiltersIndicator(): Nullable<IFilterIndicatorRenderingOptions> {
        return null;
    }

    showFiltersEditor(): void {
    }

    dispose(): void {
    }

    getNumberOfGamesBeforeUserApply(filterIDS: string[]): number {
        return 0;
    }
}